import Reveal from "@stimulus-components/reveal"
import ahoy from 'ahoy.js';

// Connects to data-controller="home-trainer-reveal"
export default class extends Reveal {
  
  
  
  connect() {
    super.connect()
  }
  
  toggle() {
    super.toggle()
    this.scroll(this.trainers_offset())
    this.track()
  }
  
  toggle_to_top() {
    super.toggle()
    this.scroll(1)
    this.track()
  }
  
  scroll(offsetPosition) {
    
    if (!offsetPosition) { return }
    
    window.scrollTo({
      top: offsetPosition,
      behavior: this.behavior(),
    })
  }
  
  trainers_offset() {
  
    const target = document.getElementById("team-trainers-frame")

    if (!target) {
      return
    }

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset
    const offsetPosition = elementPosition - this.offset()
    
    return offsetPosition;

  }
  
    offset() {
      return 10
    }
    
    behavior() {
      return 'smooth'
    }
  
    track() {
      ahoy.track("$view", {url: event.currentTarget.parentElement.action, page: window.location.href, title: event.currentTarget.dataset.teamMemberLabel, team_member_id: event.currentTarget.dataset.teamMemberId });
    } 
}
